var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3506 24.521L20.0339 2.43471C19.1798 0.910382 17.6713 0 15.9988 0C14.3263 0 12.8178 0.910382 11.9637 2.43471C11.9572 2.44637 11.9518 2.45803 11.9454 2.46969L0.66634 24.486C-0.206099 26.0425 -0.222599 27.9117 0.621403 29.4856C1.46734 31.0605 2.99134 32 4.70054 32H27.2346C28.9438 32 30.5304 31.0605 31.3763 29.4856C32.2203 27.9118 32.2038 26.0424 31.3506 24.521ZM14.1219 10.1129C14.1219 9.01391 14.9622 8.12314 15.9988 8.12314C17.0354 8.12314 17.8757 9.01398 17.8757 10.1129V18.0718C17.8757 19.1706 17.0354 20.0615 15.9988 20.0615C14.9622 20.0615 14.1219 19.1706 14.1219 18.0718V10.1129V10.1129ZM15.9988 28.0206C14.4464 28.0206 13.1834 26.6818 13.1834 25.0359C13.1834 23.3901 14.4463 22.0513 15.9988 22.0513C17.5512 22.0513 18.8141 23.3901 18.8141 25.0359C18.8142 26.6817 17.5513 28.0206 15.9988 28.0206Z",
    fill: "#D51A1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.45685bc5169087a1ce705001008a52fa.svg";
export { ForwardRef as ReactComponent };